"use strict";
appHost.plugins.register({
    // #region Vars
    name: "288a.web.admin",
    // #endregion
    // #region Register
    register() {
        appHost.components.registerAll(require.context('./views', true, /(?<!views)\.vue$/));
    },
    // #endregion
});
